import dynamicLocalization from "@/mixins/dynamic-localization";
import Iconized from "@/components/iconized/index";
import IconizedButton from "@/components/iconized-button/index";
import DateToFormat from "@/components/date-to-format/index";
import TimeRange from "@/components/time-range/index";
import TextContentBlock from "@/components/content-block/text/index";

export default {
  mixins: [dynamicLocalization],
  components: {
    DateToFormat,
    Iconized,
    IconizedButton,
    TextContentBlock,
    TimeRange,
  },
  props: ["event", "nextEvent", "prevEvent"],
};
